var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module",class:[_vm.width, _vm.tall, _vm.isDragging ? 'dragging' : ''],style:(_vm.position),on:{"mousedown":function($event){$event.stopPropagation();_vm.startDragging($event)}}},[_c(_vm.module.type,{tag:"component",attrs:{"id":_vm.module.id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c11f41a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/Module.vue
// module id = +GxS
// module chunks = 0